// extracted by mini-css-extract-plugin
export default {"basicBtn":"Button_basicBtn__Fqslu","accentBtn":"Button_accentBtn__FrUo9 Button_basicBtn__Fqslu","secondaryBtn":"Button_secondaryBtn__DoN9Z Button_basicBtn__Fqslu"};